import { render } from "./DDCookieNotice.vue?vue&type=template&id=12f4adba"
import script from "./DDCookieNotice.vue?vue&type=script&lang=js"
export * from "./DDCookieNotice.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__